<template>
    <v-layout row wrap class="mt-2">
        <v-flex xs12 sm12 md7 mt-2>
            <v-card class="mx-auto mr-3 ml-3" width="100%">
                <v-card-title class="justify-center primary">
                    <v-toolbar-title id="titulocard">Restablecer Firma Electrónica</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-icon :color="'#FFFFFF'">mdi-form-textbox-password</v-icon>
                </v-card-title>
                <v-card-text>
                    <span style="font-size:16px" id="password">
                        La Firma Electrónica es de carácter personal y nadie tendrá acceso a esta clave, (inclusive
                        personal de sistemas), por lo que deberá ser una clave difícil, pero al mismo tiempo fácil de
                        recordar.
                    </span>
                    <v-alert border="right" colored-border type="error" elevation="2" class="mt-2">
                        El almacenamiento en la base de datos es de encriptación a 32 bits, lo cual garantiza la
                        seguridad de la misma y los hace responsables de su uso.
                    </v-alert>
                    <div>
                        <vs-list>
                            <vs-list-item class="lista" style="color:#536DFE "
                                subtitle="Evitar poner números seguidos 1234."></vs-list-item>
                            <vs-list-item class="lista" style="color:#536DFE "
                                subtitle="Evitar poner letras continuas AABBaacc."></vs-list-item>
                            <vs-list-item class="lista" style="color:#536DFE "
                                subtitle="Evitar utilizar palabras comunes o albures."></vs-list-item>
                        </vs-list>
                        <vs-list>
                            <vs-list-item style="font-size:16px !important" class="lista" id="caracteres"
                                subtitle="Debe tener un mínimo de 8 caracteres y un máximo de 16 caracteres.">
                            </vs-list-item>
                            <vs-list-item class="lista" id="fortaleza"
                                subtitle="Debe tener un mínimo de grado de fortaleza de 80%.">
                            </vs-list-item>
                            <vs-list-item class="lista" id="numero" subtitle="Deberá de contener números (0 … 9).">
                            </vs-list-item>
                            <vs-list-item class="lista" id="letras"
                                subtitle="Letras en mayúsculas y minúsculas (a… z, A… Z).">
                            </vs-list-item>
                            <vs-list-item class="lista" id="sCaracter"
                                subtitle="Por lo menos un carácter especial de los permitidos (#$%&/()?_!.*\@@+:,).">
                            </vs-list-item>
                            <vs-list-item class="lista" id="nCaracteres"
                                subtitle="Caracteres NO PERMITIDOS (<,>,-,^,',=,ñ,Ñ,{,},;).">
                            </vs-list-item>
                        </vs-list>

                    </div>
                </v-card-text>
            </v-card>
        </v-flex>
        <v-flex xs12 sm12 md5 mt-2>
            <v-card class="mx-auto mr-3 ml-3" width="100%">
                <v-card-text style="margin-top: 20px;">
                    <v-form v-model="valid" lazy-validation ref="formreporte" mt-3 style="margin:5px">
                        <v-label>Ingrese su contraseña</v-label>
                        <v-text-field v-model="passactual" outlined persistent-hint :rules="passwordRule"
                            :append-icon="value ? 'mdi-eye' : 'mdi-eye-off'" :counter="16"
                            @click:append="() => (value = !value)" :type="value ? 'text' : 'password'" maxlength="16"
                            @keydown.space.prevent></v-text-field>
                        <div v-if="valfirma">
                            <v-label>Ingrese firma electrónica actual:</v-label>
                            <v-text-field v-model="firmaActual" outlined persistent-hint
                                :append-icon="valuef ? 'mdi-eye' : 'mdi-eye-off'" :counter="16"
                                @click:append="() => (valuef = !valuef)" :type="valuef ? 'text' : 'password'"
                                :rules="firmaRules" maxlength="16" @keydown.space.prevent></v-text-field>
                        </div>
                        <v-label>Ingrese su nueva firma electrónica</v-label>
                        <v-text-field v-model="firmaNueva" outlined persistent-hint :rules="firmaRules"
                            :append-icon="valuefn ? 'mdi-eye' : 'mdi-eye-off'" :counter="16"
                            @click:append="() => (valuefn = !valuefn)" :type="valuefn ? 'text' : 'password'"
                            maxlength="16" @keydown.space.prevent></v-text-field>
                        <v-label>Repita su nueva firma electrónica</v-label>
                        <v-text-field v-model="firmaNuevaC" outlined persistent-hint :rules="passwordRules"
                            :append-icon="valuefr ? 'mdi-eye' : 'mdi-eye-off'" :counter="16"
                            @click:append="() => (valuefr = !valuefr)" :type="valuefr ? 'text' : 'password'"
                            maxlength="16" @keydown.space.prevent></v-text-field>
                        <v-progress-linear :color="color" height="20" :value="progress">
                            <strong>{{ this.progress }}%</strong>
                        </v-progress-linear>
                    </v-form>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions style="justify-content: center; align-content:end; padding: 20px;">
                    <div mt-2 style="text-align: center;">
                        <v-btn class="mr-4 mt-3" color="success" @click="RestablecerPass"
                            :disabled="disbtn">Restablecer</v-btn>
                        <v-btn v-if="btncancelar" class="mr-4 mt-3" color="secondary" @click="Cancelar"
                            :disabled="disbtn">Cancelar</v-btn>
                        <v-btn class="mr-4 mt-3" color="default" @click="limpiar" :disabled="disbtn">Limpiar</v-btn>
                    </div>
                </v-card-actions>
            </v-card>
        </v-flex>
    </v-layout>
</template>


<script>
import { mapActions, mapState } from 'vuex'
import MetodosGenerales from '@/utils/metodosgenerales.vue.js';
import LocalStorage from '@/utils/managerLocalStorage.js';
import PerfilServ from '@/services/main/perfil.service.js';


export default {

    data: () => ({
        passwordRule: [
            v => !!v || 'Se requiere contraseña',
        ],
        valfirma: false,
        valid: true,
        passwordRules: [
            v => !!v || 'Se requiere contraseña',
            v => (v && v.length >= 8) || 'La contraseña debe tener más de 8 caracteres',
            v => (v && v.length <= 16) || 'La contraseña debe tener igual o menos de 16 caracteres',
            v => /(?=.*[A-Z])/.test(v) || 'Debe tener un carácter en mayúsculas',
            v => /(?=.*\d)/.test(v) || 'Debe tener un número',
            v => /([#$%&/()?_!.*@+:,])/.test(v) || 'Debe tener un carácter especial [#$%&/()?_!.*@+:,]',
            v => /(?=.*[a-z])/.test(v) || 'Debe tener un carácter en minúscula',
        ],
        firmaRules: [
            v => !!v || 'Se requiere firma electrónica',
            v => (v && v.length >= 8) || 'La firma electrónica debe tener más de 8 caracteres',
            v => (v && v.length <= 16) || 'La firma electrónica debe tener igual o menos de 16 caracteres',
            v => /(?=.*[A-Z])/.test(v) || 'Debe tener un carácter en mayúsculas',
            v => /(?=.*\d)/.test(v) || 'Debe tener un número',
            v => /([#$%&/()?_!.*@+:,])/.test(v) || 'Debe tener un carácter especial [#$%&/()?_!.*@+:,]',
            v => /(?=.*[a-z])/.test(v) || 'Debe tener un carácter en minúscula',
        ],
        value: false,
        passactual: '',
        firmaActual: '',
        valuef: false,
        btncancelar: true,
        firmaNueva: '',
        valuefn: false,
        caracteres: false,
        colorinicial: '',
        firmaNuevaC: '',
        valuefr: false,
        fortaleza: false,
        mensaje: '',
        validacion: 0,
        disbtn: false,
        validarfirma: false,
    }),
    watch: {
        'firmaNueva'(val) {
            switch (val.length >= 8) {
                case (true):
                    this.caracteres = true
                    document.getElementById('caracteres').style.color = "#3CD4A0";
                    break;
                case (false):
                    this.caracteres = false;
                    document.getElementById('caracteres').style.color = this.colorinicial;
                    break;
            }
            switch (!MetodosGenerales.validarRegex(val, "NU")) {
                case (true):
                    this.numero = true
                    document.getElementById('numero').style.color = "#3CD4A0";
                    break;
                case (false):
                    this.numero = false;
                    document.getElementById('numero').style.color = this.colorinicial;
                    break;
            }
            switch (!MetodosGenerales.validarRegex(val, "LT")) {
                case (true):
                    this.letras = true
                    document.getElementById('letras').style.color = "#3CD4A0";
                    break;
                case (false):
                    this.letras = false;
                    document.getElementById('letras').style.color = this.colorinicial;
                    break;
            }
            switch (!MetodosGenerales.validarRegex(val, "SC")) {
                case (true):
                    this.sCaracter = true
                    document.getElementById('sCaracter').style.color = "#3CD4A0";
                    break;
                case (false):
                    this.sCaracter = false;
                    document.getElementById('sCaracter').style.color = this.colorinicial;
                    break;
            }
            switch (!MetodosGenerales.EvaluarInvalidos(val)) {
                case (true):
                    this.nCaracteres = true
                    document.getElementById('nCaracteres').style.color = "#3CD4A0";
                    break;
                case (false):
                    this.nCaracteres = false;
                    document.getElementById('nCaracteres').style.color = this.colorinicial;
                    break;
            }
            if (val.length == 0) {
                this.nCaracteres = false
                document.getElementById('nCaracteres').style.color = this.colorinicial;
            }
        },
        'fortaleza'(val) {
            if (val) {
                document.getElementById('fortaleza').style.color = "#3CD4A0";
            } else {
                document.getElementById('fortaleza').style.color = this.colorinicial;

            }
        },
        'local'() {
            this.colorinicial = this.local.nocturno == true ? 'white' : 'black'
            document.getElementById('password').style.color = this.colorinicial;
            if (this.caracteres == false) {
                document.getElementById('caracteres').style.color = this.colorinicial;
            }
            if (this.numero == false) {
                document.getElementById('numero').style.color = this.colorinicial;
            }
            if (this.letras == false) {
                document.getElementById('letras').style.color = this.colorinicial;
            }
            if (this.sCaracter == false) {
                document.getElementById('sCaracter').style.color = this.colorinicial;
            }
            if (this.sCaracter == false) {
                document.getElementById('sCaracter').style.color = this.colorinicial;
            }
            if (this.nCaracteres == false) {
                document.getElementById('nCaracteres').style.color = this.colorinicial;
            }
            if (this.fortaleza == false) {
                document.getElementById('fortaleza').style.color = this.colorinicial;
            }
        }
    },
    computed: {
        ...mapState({ drawer: state => state.drawer }),
        ...mapState(['domain', 'informationPage']),
        DRAWER_STATE: {
            get() {
                return this.drawer
            },
        },
        progress() {
            var porcentajeSeguridad = MetodosGenerales.ValidarPass(this.firmaNueva);
            return porcentajeSeguridad
        },
        color() {
            var colorprogress = ''
            if (this.progress == 0) {
                colorprogress = '#CECCCE'
                this.fortaleza = false;
            } else if (this.progress < 35) {
                colorprogress = 'error'
                this.fortaleza = false;
            } else if (this.progress < 80 && this.progress >= 35) {
                colorprogress = 'warning'
                this.fortaleza = false;
            } else if (this.progress >= 80) {
                colorprogress = 'success'
                this.fortaleza = true;
            }
            return colorprogress
        },
    },
    methods: {
        ...mapActions(['TOGGLE_DRAWER']),
        async Validacion() {
            this.validarfirma = true;
            this.$refs.formreporte.validate()
            this.validacion = 0;
            if (this.$refs.formreporte.validate()) {
                this.mensaje = '<p align = "left" >Deberá verificar la siguiente información: </p> <ul class="lista">';
                if (this.firmaNueva == this.firmaActual) {
                    this.mensaje = this.mensaje + '<li>La nueva Firma no puede ser igual a la Firma actual, vuelva a intentarlo.</li>'
                    this.validacion++;
                }
                if (this.firmaNueva != this.firmaNuevaC) {
                    /* Validar ambas firmas nuevas que coincidan*/
                    this.mensaje = this.mensaje + '<li>La nueva firma y la confirmación no coinciden, favor de verificarlo.</li>'
                    this.validacion++;
                }
                if (this.progress < 80) {
                    this.mensaje = this.mensaje + '<li>El nivel mínimo de seguridad es de un 80%.</li>'
                    this.validacion++;
                }
                if (!this.nCaracteres) {
                    this.mensaje = this.mensaje + '<li>La nueva firma contiene caracteres no válidos, favor de verificarlo.</li>'
                    this.validacion++;
                }
                //Validar Contraseña
                let valpassword = await PerfilServ.ValidarContrasenia(this.passactual);
                if (!valpassword) {
                    this.mensaje = this.mensaje + '<li>La contraseña es incorrecta.</li>'
                    this.validacion++;
                }
                //Validar Firma
                if (this.valfirma) {
                    let validfirma = await PerfilServ.ValidarEFirma(this.firmaActual);
                    if (validfirma.length == 0) {
                        this.mensaje = this.mensaje + '<li>La firma electrónica  actual es incorrecta.</li>'
                        this.validacion++;
                    }
                    if (this.passactual == this.firmaNueva) {
                        this.mensaje = this.mensaje + '<li>La Firma ingresada es igual a la contraseña, favor de ingresar otra Firma.</li>'
                        this.validacion++;
                    }
                    let valConcidencias = await PerfilServ.VerificarCoincidenciasFirma(this.firmaActual, this.firmaNueva);
                    if (valConcidencias == true) {
                        this.mensaje = this.mensaje + '<li>La nueva Firma es similar a la anterior y/o el usuario no puede formar parte de la nueva Firma, favor de verificar.</li>'
                        this.validacion++;
                    }
                    ///Validar Similitud de firmas
                }
                if (this.firmaNueva != '') {
                    let valContenido = await PerfilServ.VerificarContenidoFirma(this.firmaNueva);
                    if (valContenido == true) {
                        this.mensaje = this.mensaje + '<li>La nueva Firma no puede contener tu nombre, apellidos o fecha de nacimiento.</li>'
                        this.validacion++;
                    }
                }
                let perfil = await PerfilServ.DatosPerfil()
                if (perfil.btnfirma == 1) {
                    this.validacion++;
                    this.mensaje = this.mensaje + '<li>La firma ya ha sido modificada recientemente.</li>';
                }

                if (this.validacion > 0) {
                    this.mensaje = this.mensaje + '</ul>'
                    this.$swal({
                        position: 'center',
                        icon: 'warning',
                        html: `${this.mensaje}`,
                        showConfirmButton: true,
                        allowOutsideClick: false,
                        confirmButtonColor: '#536DFE',
                        confirmButtonText: 'Aceptar',
                    }).then(async () => {
                        if (perfil.btnfirma == 1) {
                            this.$emit('BtnCancelar')
                        }
                    });
                }
            } else {
                this.validacion++;
            }
            this.validarfirma = false;

        },
        async RestablecerPass() {
            await this.Validacion()
            if (this.validacion == 0) {
                this.disbtn = true;
                this.$swal({
                    title: 'Modificando firma electrónica, espere, por favor.',
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                    didOpen: async () => {
                        this.$swal.showLoading();
                        let valresponse = await PerfilServ.ModificarFirma(this.firmaNueva);
                        if (valresponse) {
                            this.$swal({
                                position: 'center',
                                icon: 'success',
                                title: 'Correcto',
                                text: 'Firma electrónica modificada correctamente.',
                                showConfirmButton: true,
                            }).then(async () => {
                                this.$emit('BtnCancelar')
                            });
                        } else {
                            this.$swal({
                                position: 'center',
                                icon: 'warning',
                                title: 'Correcto',
                                text: 'Ocurrió un error, al modificar la firma electrónica, intente nuevamente más tarde, si el problema persiste, pónganse en contacto con el área de soporte.',
                                showConfirmButton: false,
                                timer: 2500
                            });
                            this.disbtn = false;
                        }
                    }
                })
            }
        },
        limpiar() {
            this.$refs.formreporte.reset();
            this.passactual = ''
            this.firmaNueva = ''
            this.firmaNuevaC = ''
            this.nCaracteres = false
        },
        Cancelar() {
            this.$emit('BtnCancelar');
        }
    },
    async mounted() {
        this.valfirma = await PerfilServ.FirmaElectronicaObtenerDatos();
    },
    updated() {
        this.local = LocalStorage.getSingleValueInLocalStorage("tema");
    }
}
</script>
<style>
.lista .vs-list--subtitle {
    font-size: 16px !important;
}
</style>